import { render } from "./PasseiosView.vue?vue&type=template&id=7331caac&lang=pug"
import script from "./PasseiosView.vue?vue&type=script&setup=true&lang=js"
export * from "./PasseiosView.vue?vue&type=script&setup=true&lang=js"

import "./PasseiosView.vue?vue&type=style&index=0&id=7331caac&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__